import ApiClient from "~/admin/services/ApiClient";
import queryString from "query-string";

export default class ReportsApi {
  static paginate = (page = null) => {
    let params = {};

    params.page = page;

    return ApiClient.get(`reports/paginate?${queryString.stringify(params)}`);
  };

  static paginateUserReports = (userId, page = null) => {
    let params = {};

    params.page = page;

    return ApiClient.get(
      `reports/paginate-user-reports/${userId}?${queryString.stringify(params)}`
    );
  };
}
